"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasConsent = exports.initLocationHashOpen = exports.initChatAnchorLinks = exports.initSkipLinks = exports.isChatButtonVisible = exports.initChatCustom = exports.initChat = void 0;
var utils_1 = require("./utils");
function initChat() {
    if (!document.querySelector('.js-chat-lcw-start'))
        return;
    var chatbotButton = document.querySelector('.js-chat-lcw-start');
    initSkipLinks(chatbotButton);
    initChatAnchorLinks(chatbotButton);
    if (!isChatButtonVisible(chatbotButton)) {
        initOfflineMessage(chatbotButton);
    }
    else {
        initTextMobileFadeOut(chatbotButton);
        initPrivacyDialog(chatbotButton, function () { return loadChat(chatbotButton); });
    }
    initLocationHashOpen(chatbotButton);
}
exports.initChat = initChat;
function initChatCustom() {
    if (!document.querySelector('.js-chat-lcw-custom-start'))
        return;
    var chatbotButton = document.querySelector('.js-chat-lcw-custom-start');
    var chatbotButtonIcon = chatbotButton.querySelector('img');
    var root = document.createElement('div');
    root.id = 'oebb-live-chat-widget';
    root.dataset.orgId = chatbotButton.dataset.orgId; // '99f9ea5c-45cf-4bf3-94e9-7e34c9fa8d69';
    root.dataset.orgUrl = chatbotButton.dataset.orgUrl; // 'https://org5563f30c-crm4.omnichannelengagementhub.com';
    root.dataset.widgetId = chatbotButton.dataset.appId; // '2c783452-d4ac-45d2-9a3f-1a5749c04f93';
    if (chatbotButtonIcon.classList.contains('js-chat-wc-button-icon-custom')) {
        root.dataset.botImageUrl = chatbotButtonIcon.src;
    }
    document.body.appendChild(root); // Append to body, to better prevent style conflicts
    initSkipLinks(chatbotButton);
    initChatAnchorLinks(chatbotButton);
    if (!isChatButtonVisible(chatbotButton)) {
        initOfflineMessage(chatbotButton);
    }
    else {
        initTextMobileFadeOut(chatbotButton);
        if (document.querySelector('.js-chat-dsgvo-disclaimer')) {
            initPrivacyDialog(chatbotButton, function () { return loadChatCustom(chatbotButton); });
        }
        else {
            chatbotButton.addEventListener('click', function (e) {
                e.preventDefault();
                loadChatCustom(chatbotButton);
            });
        }
    }
    initLocationHashOpen(chatbotButton);
}
exports.initChatCustom = initChatCustom;
function isChatButtonVisible(button) {
    var fromHours = button.dataset.availableFrom ? parseInt(button.dataset.availableFrom) : 0;
    var toHours = button.dataset.availableTo ? parseInt(button.dataset.availableTo) : 24;
    var from = new Date(new Date().getFullYear(), 3 - 1, 29); // Start of DST in Europe: 29.03.
    var to = new Date(new Date().getFullYear(), 10 - 1, 25); // End of DST in Europe 25.10.
    var now = new Date();
    var offset = '+1';
    if (now >= from && now <= to)
        offset = '+2';
    var utc = now.getTime() + now.getTimezoneOffset() * 60000;
    var viennaHours = new Date(utc + 3600000 * offset).getHours();
    if (viennaHours >= fromHours && viennaHours < toHours)
        return true;
    return false;
}
exports.isChatButtonVisible = isChatButtonVisible;
function initSkipLinks(button) {
    var skipLinks = document.querySelector('.skip-links');
    if (!skipLinks)
        return;
    var link = document.createElement('a');
    link.href = "#".concat(button.id);
    link.className = 'screen-reader-text';
    link.accessKey = '2';
    link.textContent = "".concat(button.dataset.skipLinkMessage, " (Alt+2)");
    skipLinks.appendChild(link);
}
exports.initSkipLinks = initSkipLinks;
function initChatAnchorLinks(button) {
    var buttonId = button.id;
    var buttonLinks = document.querySelectorAll("[href=\"#".concat(buttonId, "\"]:not(.screen-reader-text)"));
    buttonLinks.forEach(function (link) {
        link.addEventListener('click', function () {
            button.click();
        });
    });
}
exports.initChatAnchorLinks = initChatAnchorLinks;
function initLocationHashOpen(button) {
    if (window.location.hash.replace(/#/, '') === button.id) {
        button.click();
    }
}
exports.initLocationHashOpen = initLocationHashOpen;
function hasConsent(consentItems) {
    if (!consentItems || consentItems.length === 0)
        return true;
    var invalidItem = null;
    consentItems.forEach(function (item) {
        var checkbox = item.querySelector('[type="checkbox"]');
        var alert = item.querySelector('.js-chat-consent-checkbox-invalid-message');
        if (!checkbox.checked) {
            item.classList.add('chat-consent-item--invalid');
            alert.textContent = alert.dataset.message;
            if (!invalidItem) {
                invalidItem = item;
            }
        }
        else {
            item.classList.remove('chat-consent-item--invalid');
            checkbox.removeAttribute('aria-invalid');
            alert.textContent = '';
        }
    });
    if (invalidItem) {
        location.href = '#' + invalidItem.querySelector('[type="checkbox"]').id;
    }
    return !invalidItem;
}
exports.hasConsent = hasConsent;
function setHiddenState(element) {
    setTimeout(function () {
        if (element.classList.contains('chat-dsgvo-popup--visible'))
            return;
        element.hidden = true;
    }, 1000);
}
function initOfflineMessage(button) {
    var offlineTitle = document.createElement('span');
    offlineTitle.classList.add('chat-wc-button__caption-offline');
    offlineTitle.textContent = button.dataset.offlineTitle;
    button.querySelector('.js-chat-wc-button-caption').appendChild(offlineTitle);
    button.insertAdjacentHTML('afterend', "\n        <div class=\"chat-wc-offline-message js-chat-wc-offline-message\">\n            <button class=\"js-chat-wc-offline-message-close\">\n                <span class=\"ic-close\" aria-hidden=\"true\"></span>\n                <span class=\"screen-reader-text\">".concat(button.dataset.closeMessage, "</span>\n            </button>\n            <p>").concat(button.dataset.offlineMessage, "</p>\n        </div>\n    "));
    button.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('.js-chat-wc-offline-message').classList.add('chat-wc-offline-message--open');
    });
    document.querySelector('.js-chat-wc-offline-message-close').addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('.js-chat-wc-offline-message').classList.remove('chat-wc-offline-message--open');
    });
}
function initTextMobileFadeOut(button) {
    (0, utils_1.onScrollInterval)(function (latestScrollY, clearScrollInterval) {
        if (latestScrollY > 300) {
            clearScrollInterval();
            button.classList.add('chat-wc-button--text-mobile-fade-out');
        }
    });
}
function initPrivacyDialog(button, loaderFn) {
    var dsgvoDisclaimer = document.querySelector('.js-chat-dsgvo-disclaimer');
    var chatbotAlternative = document.querySelector('.js-chat-dsgvo-alternative');
    var disclaimerCloseBtn = document.querySelector('.js-btn-close-disclaimer');
    var alternativeCloseBtn = document.querySelector('.js-btn-close-alternative');
    var dsgvoConfirmButton = document.querySelector('.js-chat-dsgvo-confirm');
    var dsgvoCancleButton = document.querySelector('.js-chat-dsgvo-cancel');
    var consentItems = document.querySelectorAll('.js-chat-consent-item');
    button.addEventListener('click', function (e) {
        e.preventDefault();
        dsgvoDisclaimer.hidden = false;
        setTimeout(function () { return dsgvoDisclaimer.classList.add('chat-dsgvo-popup--visible'); }); // Timeout to wait for "hidden" attribute
        disclaimerCloseBtn.focus();
    });
    disclaimerCloseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        this.parentElement.classList.remove('chat-dsgvo-popup--visible');
        setHiddenState(dsgvoDisclaimer);
        button.focus();
    });
    if (alternativeCloseBtn && chatbotAlternative) {
        alternativeCloseBtn.addEventListener('click', function (e) {
            e.preventDefault();
            this.parentElement.classList.remove('chat-dsgvo-popup--visible');
            setHiddenState(chatbotAlternative);
            button.focus();
        });
    }
    dsgvoConfirmButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (!hasConsent(consentItems)) {
            return;
        }
        dsgvoDisclaimer.classList.remove('chat-dsgvo-popup--visible');
        setHiddenState(dsgvoDisclaimer);
        loaderFn();
    });
    dsgvoCancleButton.addEventListener('click', function (e) {
        e.preventDefault();
        dsgvoDisclaimer.classList.remove('chat-dsgvo-popup--visible');
        setHiddenState(dsgvoDisclaimer);
        if (alternativeCloseBtn && chatbotAlternative) {
            chatbotAlternative.hidden = false;
            setTimeout(function () { return chatbotAlternative.classList.add('chat-dsgvo-popup--visible'); }); // Timeout to wait for "hidden" attribute
            alternativeCloseBtn.focus();
        }
        if (document.querySelector('#Microsoft_Omnichannel_LCWidget')) {
            document.querySelector('#Microsoft_Omnichannel_LCWidget').remove();
            document.querySelector('#Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window').remove();
        }
    });
}
function loadChat(button) {
    var _a, _b, _c;
    var openChat = function () {
        Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
    };
    if (document.querySelector('#Microsoft_Omnichannel_LCWidget')) {
        openChat();
    }
    else {
        var scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.src = 'https://oc-cdn-public-eur.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js';
        scriptElement.id = 'Microsoft_Omnichannel_LCWidget';
        scriptElement.dataset.appId = (_a = button.dataset.appId) !== null && _a !== void 0 ? _a : '8a73df4a-65e6-4ad6-9d48-65ea0a096c1d';
        scriptElement.dataset.orgId = (_b = button.dataset.orgId) !== null && _b !== void 0 ? _b : '99f9ea5c-45cf-4bf3-94e9-7e34c9fa8d69';
        scriptElement.dataset.orgUrl = (_c = button.dataset.orgUrl) !== null && _c !== void 0 ? _c : 'https://org5563f30c-crm4.omnichannelengagementhub.com';
        if (button.dataset.lcwVersion)
            scriptElement.dataset.lcwVersion = button.dataset.lcwVersion;
        // scriptElement.dataset.suggestedActionLayout = 'stacked'; // If this is activated, color does not work anymore for suggested actions
        scriptElement.dataset.colorOverride = '#e2002a';
        scriptElement.dataset.fontFamilyOverride = 'Arial, Helvetica, sans-serif';
        // scriptElement.dataset.hideChatButton = 'true'; // Leaves hidden IFrame and makes areas behind unclickable
        document.body.appendChild(scriptElement);
        var chatbotButtonTextContent_1 = button.querySelector('span').textContent;
        button.querySelector('span').textContent = button.dataset.loadingMessage;
        window.addEventListener('lcw:ready', function () {
            button.querySelector('span').textContent = chatbotButtonTextContent_1;
            button.style.display = 'none';
            openChat();
        });
    }
}
function loadChatCustom(button) {
    var chatbotButtonTextContent = button.querySelector('span').textContent;
    button.querySelector('span').textContent = button.dataset.loadingMessage;
    (0, utils_1.loadScript)((0, utils_1.getResourceUrl)('js/main-chat-lcw.min.js'));
    window.addEventListener('oebb:lcw:ready', function () {
        button.querySelector('span').textContent = chatbotButtonTextContent;
        button.style.display = 'none';
    });
}
